import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { Observable, of } from 'rxjs';
import { environment } from 'projects/access-control/src/environments/environment';
import { ApiService } from '../../Services/api.service';

@Injectable({
	providedIn: 'root',
})
export class GroupService {
	constructor(private api: ApiService, private http: HttpClient) {}

	getGroups() {
		return this.api.get<any>('/groups/');
	}
	getAllGroups() {
		return this.api.get<any>('/all-groups');
	}
	getSubGroup(pk: string, sk: string) {
		return this.api.get<any>(`/groups/${pk}/${sk}/subgroups`);
	}
	getUserGroup(pk: string, sk: string, page: number = 1) {
		return this.api.get<any>(`/groups/sub-groups/` + pk + '/' + sk + `?_size=10&_page=${page}`);
	}
	getDetailGroup(url: string) {
		return this.api.getFullPath(url);
	}
	deleteGroup(ids: IPkSk) {
		return this.api.delete(`/groups/${ids.pk}/${ids.sk}`, {});
	}

	createGroup(data: Groups): Observable<any> {
		return this.api.post('/groups/', data);
	}
	updateGroup(data: Groups, ids: IPkSk): Observable<any> {
		return this.api.patch(`/groups/${ids.pk}/${ids.sk}`, data);
	}

	getUsersGroup(groups: IPkSk, paginationTo: number = 1): Observable<any> {
		return this.api.get<any>(
			`/groups/${groups.pk}/${groups.sk}/users?_size=10&_page=${paginationTo}`
		);
	}
	searchUsersGroup(groups: IPkSk, url: string): Observable<any> {
		return this.api.get<any>(`/groups/${groups.pk}/${groups.sk}/users/query${url}`);
	}
	createUsersGroup(user: UsersGroups): Observable<any> {
		return this.api.post<any>(`/users`, user);
	}

	updateUsersGroup(user: UsersGroups, ids: IPkSk): Observable<any> {
		return this.api.patch<any>(`/users/${ids.pk}/${ids.sk}`, user);
	}

	deleteUsersGroup(user: IPkSk): Observable<any> {
		return this.api.delete<any>(`/users/${user.pk}/${user.sk}`, user);
	}

	bulkDeleteGroup(users: string[], ids: IPkSk) {
		return this.api.patch(`/users/${ids.pk}/${ids.sk}/groups`, { users });
	}
}
